module.exports = __webpack_public_path__ + "static/icons/icon-mountain--top-b240446f46bc8c39d6546cd84ae867c3.svg";